function useFlags(): Record<string, boolean> {
  return {
    addonsAvailable: import.meta.env.VITE_FEATURE_ADDONS_ENABLED === "true",
  };
}

export { useFlags };
